(() => {
  "use strict";
  var e = {
      d: (t, o) => {
        for (var r in o)
          e.o(o, r) &&
            !e.o(t, r) &&
            Object.defineProperty(t, r, { enumerable: !0, get: o[r] });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
      r: (e) => {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(e, "__esModule", { value: !0 });
      },
    },
    t = {};
  e.r(t), e.d(t, { ProductComparisonV2: () => ProductComparisonV2 });
  class ProductComparisonV2 extends HTMLElement {
    constructor() {
      super();
    }
    updateLayout() {
      const e = this.querySelector(".product-comparison");
      e && e.classList.toggle("hidden", !1);
    }
    dateCheck() {
      const { start_date: e, end_date: t } = this.settings.dateSettings,
        o = new Date(),
        r = new Date(e);
      return o < new Date(t) && o > r;
    }
    desktopScrollToDrag() {
      const e = this.querySelector(".product-comparison__items-wrapper");
      if (e) {
        let t,
          o,
          r = !1;
        e.addEventListener("mousedown", (s) => {
          (r = !0),
            (t = s.pageX - e.offsetLeft),
            (o = e.scrollLeft),
            (e.style.cursor = "grabbing"),
            (e.style.userSelect = "none");
        }),
          e.addEventListener("mouseleave", () => {
            (r = !1), (e.style.cursor = "auto"), (e.style.userSelect = "auto");
          }),
          e.addEventListener("mouseup", () => {
            (r = !1), (e.style.cursor = "auto"), (e.style.userSelect = "auto");
          }),
          e.addEventListener("mousemove", (s) => {
            if (!r) return;
            s.preventDefault();
            const n = s.pageX - e.offsetLeft,
              a = o - 0.5 * (n - t);
            requestAnimationFrame(() => {
              e.scrollLeft = a;
            });
          });
      }
    }
    connectedCallback() {
      DomReadyPromise().then(() => {
        let e = this.querySelector(":scope > template");
        if (
          ((this.settings = JSON.parse(e.innerHTML)),
          this.settings.dateSettings.enabled)
        ) {
          if (!this.dateCheck()) return void this.remove();
          this.updateLayout();
        } else this.updateLayout();
        this.desktopScrollToDrag(), e.remove();
      });
    }
  }
  customElements.get("product-comparison-v2") ||
    customElements.define("product-comparison-v2", ProductComparisonV2);
  var o = self;
  for (var r in t) o[r] = t[r];
  t.__esModule && Object.defineProperty(o, "__esModule", { value: !0 });
})();
